import { IMAGES } from '../../lib/api-routes'
import { HttpResponse, instance } from '../../lib/axiosInstance'

export interface GetCommunityPlanImagesParams {
  communityNumber: string
  planNumber: string
}

export interface ICommunityPlanImagesMetaData {
  communityNumber: string
  planNumber: string
}

export interface IGetCommunityPlanImagesRequest {
  basePlans: ICommunityPlanImagesMetaData[]
}

export interface CommunityPlanImagesResponse {
  images: Record<string, unknown[]>
  metadata?: unknown
}

export const getCommunityImages = async (
  params: GetCommunityPlanImagesParams
): Promise<HttpResponse<CommunityPlanImagesResponse> | undefined> => {
  try {
    const { communityNumber, planNumber } = params

    const endpoint: string = IMAGES

    const requestBody: IGetCommunityPlanImagesRequest = {
      basePlans: [
        {
          communityNumber,
          planNumber,
        },
      ],
    }
    return await instance.post<CommunityPlanImagesResponse>(
      endpoint,
      requestBody
    )
  } catch (error) {
    return undefined
  }
}
